// import { createContext, useEffect, useState } from "react";

// export const LanguageContext = createContext();

// const DEFAULT_LANG = "en";
// const SUPPORTED_LANGS = ["en", "ar", "ku"];
// const RTL_LANGS = ["ar", "ku"];

// export const LanguageProvider = ({ children }) => {
//   const [currentLang, setCurrentLang] = useState(() => {
//     const saved = localStorage.getItem("cms_lang");
//     return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
//   });

//   useEffect(() => {
//     localStorage.setItem("cms_lang", currentLang);

//     const isRTL = RTL_LANGS.includes(currentLang);

//     // ---- DIR + LANG ----
//     document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
//     document.documentElement.setAttribute("lang", currentLang);

//     // ---- FONT CLASS CONTROL ----
//     document.body.classList.remove("lang-ar");

//     if (currentLang === "ar" || currentLang === "ku") {
//       document.body.classList.add("lang-ar");
//     }
//   }, [currentLang]);

//   const changeLanguage = (lang) => {
//     if (!SUPPORTED_LANGS.includes(lang)) return;
//     setCurrentLang(lang);
//   };

//   return (
//     <LanguageContext.Provider
//       value={{
//         currentLang,
//         changeLanguage,
//         isRTL: RTL_LANGS.includes(currentLang),
//       }}
//     >
//       {children}
//     </LanguageContext.Provider>
//   );
// };



import { createContext, useEffect, useMemo, useState } from "react";

import en from "../locales/en.json";
import ar from "../locales/ar.json";
import ku from "../locales/ku.json";

export const LanguageContext = createContext();

const DEFAULT_LANG = "en";
const SUPPORTED_LANGS = ["en", "ar", "ku"];
const RTL_LANGS = ["ar", "ku"];

const localeMap = { en, ar, ku };

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    const saved = localStorage.getItem("cms_lang");
    return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
  });

  const isRTL = RTL_LANGS.includes(currentLang);

  const translations = useMemo(() => {
    return localeMap[currentLang] || localeMap[DEFAULT_LANG];
  }, [currentLang]);

  useEffect(() => {
    localStorage.setItem("cms_lang", currentLang);

    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", currentLang);

    document.body.classList.remove("lang-ar");

    if (isRTL) {
      document.body.classList.add("lang-ar");
    }
  }, [currentLang, isRTL]);

  const changeLanguage = (lang) => {
    if (!SUPPORTED_LANGS.includes(lang)) return;
    setCurrentLang(lang);
  };

  // -------- JSON TRANSLATION FUNCTION --------
  const t = (key, variables = null) => {
    const keys = key.split(".");
    let value = translations;

    for (let k of keys) {
      if (value && typeof value === "object" && k in value) {
        value = value[k];
      } else {
        return key; // fallback
      }
    }

    // Optional interpolation
    if (variables && typeof value === "string") {
      Object.keys(variables).forEach((varKey) => {
        value = value.replace(
          new RegExp(`{${varKey}}`, "g"),
          variables[varKey]
        );
      });
    }

    return value;
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLang,
        changeLanguage,
        isRTL,
        t, // for JSON
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
